import React, { useState } from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import Button from '../../../../components/Button/Button';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import {
  getStringSearchOr,
  getStringSearchPlaceholder,
} from '../../../../helpers/search';

const stringSearchFields = [
  {
    field: 'name',
    label: 'Name',
  },
  {
    field: 'phones.value',
    label: 'Phone',
  },
  {
    field: 'emails.value',
    label: 'Email',
  },
  {
    field: 'contactAddress.street1',
    label: 'Address',
  },
  {
    field: 'contactAddress.street2',
    label: null,
  },
];

type FilterBarCompaniesProps = FilterBarProps<Record<string, any>>;

const FilterBarCompanies: React.FC<FilterBarCompaniesProps> = (props) => {
  const { filters = {}, setFilters, selectedId } = props;
  const [stringSearch, setStringSearch] = useState<string>('');

  return (
    <Flex variant="filterBar.container" {...(props as any)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          autoFocus={isBrowser && !selectedId}
          width={350}
          value={stringSearch}
          onChange={(event) => {
            setStringSearch(event.target.value);
            if (setFilters) {
              setFilters({
                ...filters,
                or: getStringSearchOr(stringSearchFields, event.target.value),
              });
            }
          }}
        />
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => {
            if (setFilters) {
              setFilters({});
            }
          }}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

FilterBarCompanies.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarCompanies;
